/**
 *
 */

(function() {
    'use strict';
    angular.module('cbl.mitomanager.wa').factory('MitomMessaggiFctr', [
        'CblMessageSrvc',
        'MitomUserSrvc',
        'MitomLabelSrvc',
        function(messaggiSrvc, userSrvc, labelSrvc) {
            var getUserProfile = () => {
                if (!userSrvc.cabelUser) return null;
                return userSrvc.cabelUser.userProfile;
            };
            const processaResponse = (response) => {
                let principal = getUserProfile();
                if (response.length > 0) {
                    let respError;
                    for (let index in response) {
                        respError = processaResponse(response[index]);
                        if (respError) {
                            return true;
                        }
                    }
                    return false;
                }

                /** Nessuna messaggio recuperabile */
                if (
                    response.data.errors &&
                    response.data.errors.length === 0 &&
                    (response.data.result === null || response.data.result === undefined)
                ) {
                    const message = {
                        message: 'Nessuna risposta ricevuta dal servizio'
                    };
                    messaggiSrvc.pushErrorMessage(message.message, principal);
                    return true;
                }

                let hasError = false;

                if (response.data) {
                    /** Error */
                    if (response.data.errors) {
                        response.data.errors.forEach((err) =>
                            messaggiSrvc.pushErrorMessage(encodeSegnalazione(response.config, err), principal)
                        );
                        hasError = hasError || response.data.errors.length > 0;
                    }
                    if (response.data.messageList) {
                        /* Message list */
                        if (response.data.messageList.fatMessages) {
                            response.data.messageList.ftaMessages.forEach((err) =>
                                messaggiSrvc.pushErrorMessage(encodeMessage(response.config, err), principal)
                            );
                            hasError =
                                hasError || response.data.messageList.errMessages.length > 0;
                        }
                        if (response.data.messageList.errMessages) {
                            response.data.messageList.errMessages.forEach((err) =>
                                messaggiSrvc.pushErrorMessage(encodeMessage(response.config, err), principal)
                            );
                            hasError =
                                hasError || response.data.messageList.errMessages.length > 0;
                        }
                        if (response.data.messageList.warMessages) {
                            response.data.messageList.warMessages.forEach((warn) =>
                                messaggiSrvc.pushErrorMessage(encodeMessage(response.config, warn), principal)
                            );
                        }
                        if (response.data.messageList.infMessage) {
                            response.data.messageList.infMessage.forEach((info) =>
                                messaggiSrvc.pushErrorMessage(encodeMessage(response.config, info), principal)
                            );
                        }
                    }

                    /** Warning */
                    if (response.data.warnings) {
                        response.data.warnings.forEach((warn) =>
                            messaggiSrvc.pushWarningMessage(
                                encodeSegnalazione(response.config, warn)
                            )
                        );
                    }

                    /** Info */
                    if (response.data.info) {
                        response.data.info.forEach((info) =>
                            messaggiSrvc.pushInfoMessage(
                                encodeSegnalazione(response.config, info)
                            )
                        );
                    }

                    /** Errori da Mito8 CRM */
                    if (response.data.errore || response.data.eccezione) {
                        let err = { message: response.data.messaggio || "Si e' verificato un errore imprevisto nei servizi, contattare l'assistenza", code: 400 };
                        messaggiSrvc.pushErrorMessage(encodeMessage(response.config, err ), principal)
                    }

                    /** Errori imprevisti */
                    if (angular.isString(response.data)) {
                        let err = { message: "Si e' verificato un errore imprevisto nei servizi, contattare l'assistenza", code: 400 };
                        messaggiSrvc.pushErrorMessage(encodeMessage(response.config, err), principal)
                    }
                }

                switch (response.status) {
                    case 401:
                        messaggiSrvc.pushErrorMessage('Sessione scaduta', principal);
                        return true;
                    case 403:
                        messaggiSrvc.pushErrorMessage('Autorizzazioni insufficienti', principal);
                        return true;
                    case 404:
                        messaggiSrvc.pushErrorMessage('Servizio non disponibile', principal);
                        return true;
                    case 502:
                    case 504:
                        messaggiSrvc.pushErrorMessage('Servizio momentaneamente non disponibile (gateway timeout)', principal);
                        return true;
                }
                return hasError;
            };

            const encodeMessage = (rConfig, message) => {
                //return `[${message.code}] ${message.message} - URL [${rConfig.method}] '${rConfig.url}'`;
                return `${message.message} ${message.code}`;
            };

            const encodeSegnalazione = (rConfig, segnalazione) => {
                // return (
                //     (!!segnalazione.codice && segnalazione.codice !== '' ?
                //         `[${segnalazione.codice}] ` :
                //         '') +
                //     `${segnalazione.descrizione} - URL [${rConfig.method}] '${rConfig.url}'`
                // );
                let code = (!!segnalazione.codice && segnalazione.codice !== '' ? `[${segnalazione.codice}] ` : '');
                return `${segnalazione.descrizione} ${code}`;
            };

            const addMessage = (message) => {
                let principal = getUserProfile();
                if (message.type === 'E' || message.type === 'F') {
                    messaggiSrvc.pushErrorMessage(message.message, principal);
                } else if (message.type === 'W') {
                    messaggiSrvc.pushWarningMessage(message.message);
                } else {
                    messaggiSrvc.pushInfoMessage(message.message);
                }
            };

            const addSuccessMessage = (message) => {
                messaggiSrvc.pushConfirmMessage(message.message);
            };

            const resetMessages = function() {
                messaggiSrvc.reset();
            };

            return {
                processaResponse: processaResponse,
                addMessage: addMessage,
                addSuccessMessage: addSuccessMessage,
                resetMessages: resetMessages
            };
        }
    ]);
})();